import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import CryptoJS from 'crypto-js'
import { getBaseURL } from '../../URLs'

export default (props) => {
    const [password, setPassword] = useState('')

    const handleClose = () => props.closeModal()

    const handleSubmitOnEnter = (e) => {
        var key = e.which || e.keyCode || 0
        key === 13 && handleLoginClick()
    }

    const handleLoginClick = () => {
        const randomiv = CryptoJS.lib.WordArray.random(128 / 8)
        const key = CryptoJS.enc.Base64.parse('bYtsiQNlLNnBQPuMiUOOHsIpNOjCfsAiDfYg5Iy8BaQ=')
        const c = CryptoJS.AES.encrypt(password, key, { iv: randomiv })
        const b64Ciphertext = c.ciphertext.toString(CryptoJS.enc.Base64)
        const b64IV = c.iv.toString(CryptoJS.enc.Base64)
        fetch(`${getBaseURL()}webapi/form/authorize`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
                formId: props.formId,
                ciphertext: b64Ciphertext,
                iv: b64IV,
            }),
        })
            .then((response) => {
                if (response.ok) {
                    setPassword('')
                    
                    props.verify(true, props.newRecordLockLevel)
                    props.closeModal()
                    return
                } else {
                    setPassword('')
                    props.verify(false, props.newRecordLockLevel)
                    return
                }
            })
            .catch((error) => {
                alert(error)
            })
    }

    return (
        <Modal
            show={props.showModal}
            dialogClassName="validated-name-signature-modal-dialog"
            backdropClassName="veil"
            animation={false}
            centered
            autoFocus={false}
            onHide={handleClose}
            onKeyPress={(e) => {
                var key = e.which || e.keyCode || 0
                key === 13 && e.preventDefault()
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'inline-block' }}>
                    Enter Password To Change Lock Level
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="form-inline">
                    <div className="form-group">
                        <label>Password:</label>
                        <input
                            name="Password"
                            type="password"
                            className="form-control form-control-sm"
                            defaultValue=""
                            autoFocus={true}
                            required
                            onKeyPress={handleSubmitOnEnter}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleLoginClick}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
